export const FAILED_TO_SELECT_TOPIC_TOAST_MESSAGE = "Failed to select topic.";
export const TOPIC_NOT_IMPLEMENTED_ALERT_MESSAGE  = "Topic not implemented.";

export const TOPIC_NAME_KEY                        = "topicName";
export const TOPIC_IMAGE_NAME_KEY                  = "topicImageName";
export const TOPIC_IMAGE_ATTRIBUTION_KEY           = "topicImageAttribution";
export const TOPIC_ID_KEY                          = "topicId";
export const TOPIC_CATEGORY_KEY                    = 'topicCategory';
export const COMMENT_COUNT_FOR_APRIL_2024_KEY      = "commentCountForApril2024";
export const SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY = "shouldRedictToHarmWatchTab";

export const GENERAL_CATEGORY                                 = "General";
export const DECEPTION_AND_MANIPULATION_CATEGORY              = "Deception and manipulation";
export const HATE_AND_DISCRIMINATION_CATEGORY                 = "Hate and discrimination";
export const HARM_TO_HEALTH_AND_WELL_BEING_CATEGORY           = "Harm to health and well-being";
export const THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY= "Threats to personal and community safety";
export const HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY        = "Harm to organizations and brands";

export const GENERAL_LANDING_PAGE_TOPICS = [
  {
    [TOPIC_NAME_KEY]: "Israel-Hamas war",
    [TOPIC_IMAGE_NAME_KEY]: "19 Image of Israel-Gaza.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Israel-Gaza_Ecrusized, influenced by user Rr016., CC BY-SA 4.0, via Wikimedia Commons",
    [TOPIC_ID_KEY]: 463,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 91834,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: true,
  },
  {
    [TOPIC_NAME_KEY]: "Donald Trump",
    [TOPIC_IMAGE_NAME_KEY]: "30 Image of Donald Trump.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Donald Trump, Gage Skidmore,  CC-BY-SA 2.0, Flickr",
    [TOPIC_ID_KEY]: 505,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 51817,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Joe Biden",
    [TOPIC_IMAGE_NAME_KEY]: "29 Image of Joe Biden.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Joe Biden, US Secretary of Defense,  CC BY 2.0, Flickr",
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [TOPIC_ID_KEY]: 504,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 33322,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Public Transport",
    [TOPIC_IMAGE_NAME_KEY]: "3 Image of Public Transport.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Public Transport, No machine-readable author provided. Calvin Teo assumed (based on copyright claims)., CC BY-SA 3.0, via Wikimedia Commons",
    [TOPIC_ID_KEY]: 483,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 23280,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Cyberbully",
    [TOPIC_IMAGE_NAME_KEY]: "18 Image of Cyberbullying.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Cyberbullying, CC0, RawPixel",
    [TOPIC_ID_KEY]: 461,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 21027,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: true,
  },
  {
    [TOPIC_NAME_KEY]: "Mental Health",
    [TOPIC_IMAGE_NAME_KEY]: "17 Image of Mental Health.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Mental Health, Let People Speak, CC BY-NC 2.0, Flickr",
    [TOPIC_ID_KEY]: 457,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 11889,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Bi-lateral relationships",
    [TOPIC_IMAGE_NAME_KEY]: "2 Image of Bi-lateral Relationship.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Bi-lateral Relationship, PNA photo courtesy of DFA, Public domain, via Wikimedia Commons",
    [TOPIC_ID_KEY]: 482,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 11575,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Lee Hsien Loong",
    [TOPIC_IMAGE_NAME_KEY]: "6 Image of Lee Hsien Loong.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Lee Hsien Loong, World Economic Forum, CC BY-NC-SA 2.0, Flickr",
    [TOPIC_ID_KEY]: 485,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 7611,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Joseph Schooling",
    [TOPIC_IMAGE_NAME_KEY]: "22 Image of Joseph Schooling.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Joseph Schooling, Ministério do Esported, CC BY-NC-SA 2.0, Flickr",
    [TOPIC_ID_KEY]: 476,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 6325,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Scams",
    [TOPIC_IMAGE_NAME_KEY]: "24 Image of Scams.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Scams, Photo by CATOS",
    [TOPIC_ID_KEY]: 500,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 3657,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "GE2025",
    [TOPIC_IMAGE_NAME_KEY]: "10 Image of polling station.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of polling station, Robert Sim, CC BY-SA 4.0, via Wikimedia Commons",
    [TOPIC_ID_KEY]: 490,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 2503,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Green and sustainability",
    [TOPIC_IMAGE_NAME_KEY]: "1 Image of Green and sustainability.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Green and sustainability, 贝莉儿 NG danist07, CC0, via Wikimedia Common",
    [TOPIC_ID_KEY]: 481,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 2092,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Budget 2024",
    [TOPIC_IMAGE_NAME_KEY]: "14 Image of Budget 2024.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Budget 2024, Photo from MOF, Singapore Budget",
    [TOPIC_ID_KEY]: 459,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 2030,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "COVID-19",
    [TOPIC_IMAGE_NAME_KEY]: "12 Image of Coronavirus.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Coronavirus via NIAID, Flickr",
    [TOPIC_ID_KEY]: 479,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 1785,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Taylor Swift",
    [TOPIC_IMAGE_NAME_KEY]: "21 Image of Taylor Swift.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Taylor Swift, Cosmopolitan UK, CC BY 3.0 via Wikimedia Commons",
    [TOPIC_ID_KEY]: 469,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 1667,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: true,
  },
  {
    [TOPIC_NAME_KEY]: "CPF",
    [TOPIC_IMAGE_NAME_KEY]: "26 Image of CPF.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of CPF, Photo from Central Provident Fund Board Singapore",
    [TOPIC_ID_KEY]: 501,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 1598,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Lawrence Wong",
    [TOPIC_IMAGE_NAME_KEY]: "5 Image of Lawrence Wong.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Lawrence Wong, 首相官邸ホームページ, CC BY 4.0, via Wikimedia Commons",
    [TOPIC_ID_KEY]: 486,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 1240,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Vaccines",
    [TOPIC_IMAGE_NAME_KEY]: "13 Image of Vaccines.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Vaccines, Alachua Country, Vaccines",
    [TOPIC_ID_KEY]: 480,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 630,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Shou Chew",
    [TOPIC_IMAGE_NAME_KEY]: "32 Image of Chew Shou Zi.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Chew Shou Zi, World Economic Forum,  CC-BY-NC-SA 2.0, Flickr",
    [TOPIC_ID_KEY]: 507,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 610,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Gen AI",
    [TOPIC_IMAGE_NAME_KEY]: "20 Image of Gen AI.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Gen AI from Shuttlestock",
    [TOPIC_ID_KEY]: 498,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 600,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "POFMA",
    [TOPIC_IMAGE_NAME_KEY]: "9 Image of POFMA.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of POFMA, via Gov SG",
    [TOPIC_ID_KEY]: 489,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 556,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Deepfakes (public perception)",
    [TOPIC_IMAGE_NAME_KEY]: "23 Image of Deepfakes.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Deepfakes from Shuttlestock",
    [TOPIC_ID_KEY]: 499,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 455,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Skillsfuture",
    [TOPIC_IMAGE_NAME_KEY]: "27 Image of Skillsfuture.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Skillsfuture, Photo from SkillsFutureSG",
    [TOPIC_ID_KEY]: 502,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 300,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Iswaran",
    [TOPIC_IMAGE_NAME_KEY]: "11 Image of S Iswaran.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of S Iswaran, from Ministry of Information & Broadcasting (GODL-India), GODL-India, via Wikimedia Commons",
    [TOPIC_ID_KEY]: 478,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 159,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: true,
  },
  {
    [TOPIC_NAME_KEY]: "GST Hike",
    [TOPIC_IMAGE_NAME_KEY]: "25 Image of GST tax hike.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of GST tax hike, via Advantus Media Inc and QuoteInspector.com, CC BY-ND 4.0",
    [TOPIC_ID_KEY]: 477,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 94,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Income disparity",
    [TOPIC_IMAGE_NAME_KEY]: "28 Image of Income Disparity.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Income Disparity, by M. Jeremy Goldman, CC BY-NC 2.0, Flickr",
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 40,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Online Safety Code",
    [TOPIC_IMAGE_NAME_KEY]: "7 Image of Online safety Code.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Online safety Code, Photo by CATOS",
    [TOPIC_ID_KEY]: 487,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 20,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Josephine Teo",
    [TOPIC_IMAGE_NAME_KEY]: "8 Image of Josephine Teo.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Josephine Teo, World Economic Forum, CC BY-NC-SA 2.0, Flickr",
    [TOPIC_ID_KEY]: 488,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 16,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Fare review",
    [TOPIC_IMAGE_NAME_KEY]: "4 Image of Fare review.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Fare review, Photo by CATOS",
    [TOPIC_ID_KEY]: 484,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: -1,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "National Day’s Rally 2023",
    [TOPIC_IMAGE_NAME_KEY]: "15 Image of National Day Rally 2023.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of National Day Rally 2023, Photo from Prime Minister's Office Singapore",
    [TOPIC_ID_KEY]: 492,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "PE2023",
    [TOPIC_IMAGE_NAME_KEY]: "16 Image of PE2023.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of PE2023 via Wikimedia Commons",
    [TOPIC_ID_KEY]: 493,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Gurwindergoar",
    [TOPIC_IMAGE_NAME_KEY]: "31 Image of gurwindergoar.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of gurwindergoar, Photo from Tiktok",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: GENERAL_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
];

export const DECEPTION_AND_MANIPULATION_LANDING_PAGE_TOPICS = [
  {
    [TOPIC_NAME_KEY]: "Misinformation",
    [TOPIC_IMAGE_NAME_KEY]: "33 Image of Fake News.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Fake News via Markus Winkler, Pexels",
    [TOPIC_ID_KEY]: 508,
    [TOPIC_CATEGORY_KEY]: DECEPTION_AND_MANIPULATION_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 2172,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Disinformation",
    [TOPIC_IMAGE_NAME_KEY]: "34 Image of Disinformation.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Disinformation via Danya Gutan, Pexels",
    [TOPIC_ID_KEY]: 509,
    [TOPIC_CATEGORY_KEY]: DECEPTION_AND_MANIPULATION_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 383,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Deceptive synthetic media",
    [TOPIC_IMAGE_NAME_KEY]: "35 Image of Deceptive Synthetic Media.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Deceptive Synthetic Media by Yaroslav Shuraev, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: DECEPTION_AND_MANIPULATION_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  }
];

export const HATE_AND_DISCRIMINATION_LANDING_PAGE_TOPICS = [
  {
    [TOPIC_NAME_KEY]: "Hate Speech",
    [TOPIC_IMAGE_NAME_KEY]: "37 Image of Hate Speech.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Hate Speech by Andrea Piacquadio, Pexels",
    [TOPIC_ID_KEY]: 462,
    [TOPIC_CATEGORY_KEY]: HATE_AND_DISCRIMINATION_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 4926,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Online Toxicity",
    [TOPIC_IMAGE_NAME_KEY]: "36 Image of Toxicity.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Toxicity by Andrea Piacquadio, Pexels",
    [TOPIC_ID_KEY]: 456,
    [TOPIC_CATEGORY_KEY]: HATE_AND_DISCRIMINATION_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 3913,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Social Bias",
    [TOPIC_IMAGE_NAME_KEY]: "38 Image of Social Bias.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Social Bias by Daniel Reche, Pexels",
    [TOPIC_ID_KEY]: 464,
    [TOPIC_CATEGORY_KEY]: HATE_AND_DISCRIMINATION_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 140,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  }
];

export const HARM_TO_HEALTH_AND_WELL_BEING_LANDING_PAGE_TOPICS = [
    {
      [TOPIC_NAME_KEY]: "Developmentally inappropriate content",
      [TOPIC_IMAGE_NAME_KEY]: "40 Image of Upset Child in Library.png",
      [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Upset Child in Library by Mikhail Nilov, Pexels",
      [TOPIC_ID_KEY]: 466,
      [TOPIC_CATEGORY_KEY]: HARM_TO_HEALTH_AND_WELL_BEING_CATEGORY,
      [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 10998,
      [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
    },
    {
    [TOPIC_NAME_KEY]: "Content that promotes suicide, self-harm and disordered eating",
    [TOPIC_IMAGE_NAME_KEY]: "39 Image of Self-Harm.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Self-Harm by Anete Lusina, Pexels",
    [TOPIC_ID_KEY]: 465,
    [TOPIC_CATEGORY_KEY]: HARM_TO_HEALTH_AND_WELL_BEING_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 523,
      [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  }
];

export const THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_LANDING_PAGE_TOPICS = [
  {
    [TOPIC_NAME_KEY]: "Violence Graphic Content",
    [TOPIC_IMAGE_NAME_KEY]: "43 Image of Violence.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Violene by Pixabay, Pexels",
    [TOPIC_ID_KEY]: 470,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 492,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Child Sexual Abuse Material (CSAM)",
    [TOPIC_IMAGE_NAME_KEY]: "41 Image of Upset Child.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Upset Child by Pixabay, Pexels",
    [TOPIC_ID_KEY]: 467,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 401,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Child Exploitation Material (CSEM)",
    [TOPIC_IMAGE_NAME_KEY]: "42 Image of Teddy Bear.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Teddy Bear by Skitterphoto, Pexels",
    [TOPIC_ID_KEY]: 468,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 379,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Content that praises, promote, glorifies, or support extremist organsation or individual",
    [TOPIC_IMAGE_NAME_KEY]: "46 Image of Extremist Organisation.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Extremist Organisation or Individual, CC0 via Rawpixel",
    [TOPIC_ID_KEY]: 473,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 349,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Pro-Terror Material",
    [TOPIC_IMAGE_NAME_KEY]: "44 Image of Pro Terror Material.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Pro Terror Material, CC1, Picryl",
    [TOPIC_ID_KEY]: 471,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 16,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Content that promotes, incites or instructs in dangerous physical behaviour",
    [TOPIC_IMAGE_NAME_KEY]: "45 Image of Dangerous Physical Behaviour.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Dangerous Physical Behaviour, by Judy Baxter, CC BY-NC-SA 2.0 via Flickr",
    [TOPIC_ID_KEY]: 472,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Content that incites, promotes or facilitate violence",
    [TOPIC_IMAGE_NAME_KEY]: "47 Image of Content Inciting Violence.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Content Inciting Violence by Luis Quintero, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: THREATS_TO_PERSONAL_AND_COMMUNITY_SAFETY_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  }
];

export const HARM_TO_ORGANIZATIONS_AND_BRANDS_LANDING_PAGE_TOPICS = [
  {
    [TOPIC_NAME_KEY]: "Content with Sadness",
    [TOPIC_IMAGE_NAME_KEY]: "48 Image of Sadness.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Sadness by Min An, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Content with Fear",
    [TOPIC_IMAGE_NAME_KEY]: "49 Image of Fear.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Fear by Sony Dude, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Content with Anger",
    [TOPIC_IMAGE_NAME_KEY]: "50 Image of Anger.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Anger by Andrea Piacquadio, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Sarcastic Comments",
    [TOPIC_IMAGE_NAME_KEY]: "51 Image of Sarcastic Comments.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Sarcastic comments, Photo by CATOS",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Emotionally Heated/Delicate Content",
    [TOPIC_IMAGE_NAME_KEY]: "52 Image of Person Holding Lighter.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Emotionally Heated / Delicate Content, Person Holding Lighter by lil artsy, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
  {
    [TOPIC_NAME_KEY]: "Destructive Criticisms",
    [TOPIC_IMAGE_NAME_KEY]: "53 Image of Destructive Criticism.png",
    [TOPIC_IMAGE_ATTRIBUTION_KEY]: "Image of Destructive Criticism by Karolina Grabowska, Pexels",
    [TOPIC_ID_KEY]: null,
    [TOPIC_CATEGORY_KEY]: HARM_TO_ORGANIZATIONS_AND_BRANDS_CATEGORY,
    [COMMENT_COUNT_FOR_APRIL_2024_KEY]: 0,
    [SHOULD_REDIRECT_TO_HARM_WATCH_TAB_KEY]: false,
  },
];



// WEBPACK FOOTER //
// ./src/features/landing-page/constants.js